import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { updateUserInfo } from 'containers/App/actions';
import APModal from 'components/Modal/APModal';
import { useAction } from 'hooks/useAction';
import { setCookie, getCookieValue } from 'utils/cookies';

const TimezoneDifferenceModal = () => {
  const [open, setIsOpen] = useState(true);
  const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const userTimezone = useSelector((state) => state.global.userInfo.timezone);
  const isInUserTimezone = currentTimezone === userTimezone;

  const declined = getCookieValue('decline-timezone-update') === currentTimezone;

  const updateTimezone = useAction((timezone) => updateUserInfo({ timezone }));

  const handleTimezoneUpdate = () => {
    updateTimezone(currentTimezone);
    setIsOpen(false);
  };

  const handleDecline = () => {
    setCookie('decline-timezone-update', currentTimezone);
    setIsOpen(false);
  };

  if (!userTimezone || isInUserTimezone || declined) {
    return null;
  }

  return (
    <APModal
      open={open}
      name="timezone-difference"
      onClose={() => setIsOpen(false)}
      actions={(
        <>
          <button
            className="button button--outline button--save"
            onClick={handleTimezoneUpdate}
          >
            Yes
          </button>
          <button
            className="button button--outline button--delete"
            onClick={handleDecline}
          >
            No
          </button>
        </>
      )}
    >
      <div className="change-timezone">
        <p>
          It looks like you’re in a new time zone.
          Would you like to change your calendar view to {currentTimezone}?
          This change won’t affect any designated project time zones.
        </p>
      </div>
    </APModal>
  );
};

export default TimezoneDifferenceModal;
